import { render, staticRenderFns } from "./PmtaCampaigns.vue?vue&type=template&id=f6fe649e&scoped=true"
import script from "./PmtaCampaigns.vue?vue&type=script&lang=js"
export * from "./PmtaCampaigns.vue?vue&type=script&lang=js"
import style0 from "./PmtaCampaigns.vue?vue&type=style&index=0&id=f6fe649e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fe649e",
  null
  
)

export default component.exports